import React from "react";
import { Switch } from "@material-ui/core";
import { SwitchContainer } from "../styles/sharedComponentStyles";

export default ({ onChange, value, leftLabel, rightLabel }) => {
  return (
    <SwitchContainer>
      {leftLabel}
      <Switch
        checked={value}
        onChange={(e) => onChange(e.target.checked)}
        color="primary"
      />
      {rightLabel}
    </SwitchContainer>
  );
};
